import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import 'tinymce';
import 'tinymce/themes/modern';
import 'tinymce/plugins/table';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/fullpage';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/toc';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/help';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/media';
import 'tinymce/plugins/textpattern';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/spellchecker';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/print';
import 'tinymce/plugins/advlist';
import {isArray, isNullOrUndefined} from 'util';

declare let tinymce: any;
@Component({
  selector: 'app-tinymice-editor',
  templateUrl: './tinymice-editor.component.html',
  styleUrls: ['./tinymice-editor.component.css']
})
export class TinymiceEditorComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() elementId: String;
  @Input() value: any = null;
  @Input() row: number = null;
  @Input() height: number = null;
  @Output() ifEditorContentChange = new EventEmitter();
  editor: any;
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    tinymce.init({
      selector: '#' + this.elementId,
      skin_url: 'assets/tinyMCE/lightgray',
      plugins: 'print preview fullpage searchreplace autolink' +
      ' directionality visualblocks visualchars fullscreen' +
      ' image link media table hr pagebreak' +
      ' nonbreaking anchor toc insertdatetime advlist lists textcolor' +
      ' wordcount imagetools' +
      '  colorpicker textpattern help',
      toolbar1: 'formatselect | bold italic underline strikethrough' +
      ' forecolor backcolor | link | alignleft aligncenter alignright' +
      ' alignjustify  | numlist bullist outdent indent  | removeformat | preview',
      image_advtab: true,
      branding: true,
      height: this.height,
      resize: true,
      setup: editor => {
        this.editor = editor;
        editor.on('change', () => {
          const content = editor.getContent();
          // console.log('Content', content);
          this.ifEditorContentChange.emit(content);
          // console.log('Content', content);
        });
      }
    });
    this.getData();
  }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    try {
      if (!isNullOrUndefined(this.editor) && !isArray(!isNullOrUndefined(this.value))) {
        // console.log('In', this.value);
        this.editor.setContent(this.value);
        // console.log('Val', this.value);
      }
    } catch (error) {
      // console.log('Error', error);
    }
  }

  ngOnDestroy() {
    try {
      tinymce.remove(this.editor);
    } catch (error) {
      // console.log('Error', error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tinymice-editor/tinymice-editor.component.ts